import { SESSION_STORAGE_KEYS } from "@/constants/constants";
import { loginRequest } from "./../authConfig";
import { useMsal } from "@azure/msal-react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";

const useLogin = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [isSSO, setIsSSO] = useState(false);

  const login = async () => {
    const requestedPath = sessionStorage.getItem(SESSION_STORAGE_KEYS.REDIRECT_PATH);
    const redirectPath = requestedPath ?? "/household";
    const activeAcc = instance.getActiveAccount();

    try {
      setIsSSO(true);
      if (activeAcc !== null) {
        await instance
          .acquireTokenSilent({
            account: activeAcc,
            ...loginRequest,
          })
          .then((response) => {
            instance.setActiveAccount(response.account);
            navigate(redirectPath);
          });
        return;
      }

      const loginResponse = await instance.ssoSilent(loginRequest);

      instance.setActiveAccount(loginResponse.account);

      navigate(redirectPath);
    } catch (err) {
      setIsSSO(false);
      setTimeout(() => {
        instance.loginRedirect({ ...loginRequest, redirectStartPage: redirectPath });
      }, 300);
    }
  };

  useEffect(() => {
    login();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isSSO };
};

export default useLogin;
